import React , { Component } from 'react';
import {NavBar} from '../Common/NavBar';

class Header extends Component {
    render(){
        return (
            <div className="App-header">
                <NavBar />
            </div>
        );
    }
}

export {Header};